import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { Dialog } from "primereact/dialog";
import React, { useEffect, useState } from "react";
import { postBrandStorePrice } from "../../../services/StorePriceCode/getPriceCode";
import { addBrandStoreBrandOfferConfig } from "../../../services/OfferManagements/OfferManagements";
import SuccessModal from "../../SuccessModal";

const StoreOfferAddModal = ({
  storeOfferModalVisible,
  setStoreOfferModalVisible,
  sendDataToStoreConfig,
  brandOffers,
  brandId,
  storeId,
  storeOffers
}) => {

  const OrderStatus = brandOffers;
  const storeOffersList = storeOffers;

  // Create a Set of IDs already present in warehouseStoreDataList
  const existingIds = new Set(
    storeOffersList?.map(item => item?.brandOffer.id)
  );

  // Keep only items that are NOT already present
  const filteredData = OrderStatus?.filter(
    item => !existingIds.has(item.id)
  );

  const [selectedStatus, setSelectedStatus] = useState([]);
     const [modalVisible, setModalVisible] = useState(false);
     const [modalStatus, setModalStatus] = useState(false);
     const [modalText, setModalText] = useState('');
     const [isButtonPressed, setIsButtonPressed] = useState(false);

  const handleStatusToggle = status => {
    const updatedStatus = [status];
    setSelectedStatus(updatedStatus);
  };
  const handleDataSubmit = () => {
    
     if (!isButtonPressed) {
          // Set the state to indicate that the button has been pressed
          setIsButtonPressed(true); 
      
    const updatedData = {
      brandOffer: {...selectedStatus[0]},
      storeId: storeId,
      status: true,
    };
    addBrandStoreBrandOfferConfig(brandId, updatedData)
      .then(response => {
        if (!response.data.error) {
          const Res = response.data;
          if (Res) {
            const message = Res.message;
            const status = Res.status;
            setStoreOfferModalVisible(false);
            sendDataToStoreConfig({
              success: true,
            });
            if (status === true) {
              setModalVisible(true);
              setModalStatus('success');
              setModalText(message);
            } else if (message === 'Already exist!') {
              setModalVisible(true);
              setModalStatus('not Success');
              setModalText(message);
            } else {
              setModalVisible(true);
              setModalStatus('not Success');
              setModalText(message);
            }
            setSelectedStatus([]);
            setIsButtonPressed(false); 
          }
        }
      })
      .catch(err => {
        console.error('Error:', err);
        setIsButtonPressed(false); 
      });
    } else {
      setIsButtonPressed(false); 
    }
  };

  const handleModalClose = () => {
    setStoreOfferModalVisible(false);
    setSelectedStatus([]);
    setIsButtonPressed(false);
  };

  return (
    <div className="flex justify-content-center">
      <Dialog
        modal
        visible={storeOfferModalVisible}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!storeOfferModalVisible) return;
          handleModalClose();
        }}
        content={({ hide }) => (
          <div
            className="flex flex-column gap-1 "
            style={{
              borderRadius: "12px",
              backgroundColor: "#fff",
            }}
          >
            <div
              className="flex border-round-xl  justify-content-between align-items-center gap-2 px-4 py-2"
              style={{
                backgroundImage:
                  "radial-gradient(circle at left top, #2B70D7, #1752AA)",
              }}
            >
              <img
                style={{
                  height: 45,
                  width: 45,
                  // alignSelf: 'center',
                }}
                src={"images/plus.png"}
              />

              <p className=" text-4xl text-primary-50 font-semibold">
                ADD OFFER
              </p>
              <Button
                label="x"
                onClick={(e) => hide(e)}
                text
                className=" text-2xl text-primary-50 border-1 border-white-alpha-30 hover:bg-white-alpha-10"
              ></Button>
            </div>
            <div
              className="h-20rem scroll-bar mb-2"
              style={{
                overflowY: "scroll",
              }}
            >
              <div className="mx-4">
                {filteredData?.length > 0 ? (
                  filteredData
                    ?.filter(item => item.status === 'ACTIVE') // Filter items with status === false
                    .map(item => (
                    <div
                      key={item.id}
                      className="flex flex-1 justify-content-between my-1"
                    >
                      <p className="text-xl font-medium">{item.name}</p>
                      <div>
                        <Checkbox
                          checked={selectedStatus.includes(item)}
                          size="20" // Increased size
                          color={
                            selectedStatus.includes(item)
                              ? "#00A3FF"
                              : "#C1C9D3"
                          }
                          onClick={() => handleStatusToggle(item)}
                        />
                      </div>
                    </div>
                  ))
                ) : (
                  <div>
                    <p className="text-xl font-medium">
                      No Store Package Found
                    </p>
                  </div>
                )}
              </div>
            </div>
            {filteredData?.length !== 0 && (
            <div className="flex ">
              <Button
                onClick={handleDataSubmit}
                className="mb-3 mx-4 border-round-xl w-full"
                disabled={
                  (selectedStatus?.length <= 0 && true) || isButtonPressed
                }
              >
                <p className=" w-full text-2xl font-semibold flex justify-content-center">
                {isButtonPressed ? 'Adding...' : 'ADD'}
                </p>
              </Button>
            </div>
            )}
          </div>
        )}
      ></Dialog>
       <div>
        <SuccessModal
          modalVisible={modalVisible}
          setModalVisible={setModalVisible}
          status={modalStatus}
          text={modalText}
        />
      </div>
    </div>
  );
};

export default StoreOfferAddModal;
